import React from 'react';
import { useHistory } from "react-router-dom";
import EntityForm from './EntityFormComponent';
import { postEntity } from '../routing/routes';

const NuevoEntity = ({entities,refreshData,setNotification}) => {
    const history = useHistory();
    const defaultEntity = {entity:'', subentities:[]}
    function create(nuevoEntity){
        postEntity(nuevoEntity)
        .catch(error => {setNotification("eOcurrió un error creando el entity!");console.error('Error:', error)})
        .then((res) => {
            refreshData()
            history.push("/entities/edit/"+res.insertedId)
            setNotification("mEntity creado correctamente!")     
        });
    }

    return <EntityForm entity={defaultEntity} entities={entities} guardarEntity={create} history={history} editing={false}/>
}

export default NuevoEntity;